<template>
    <div>
        <Alert :alert="alert" />
        <input v-model="email" placeholder="Digite seu email" required type="email" />
        <input class="btn btn-wide btn-beer" type="button" value="Cadastrar" @click="submit" />
    </div>
</template>

<script>
    import Alert from '../common/Alert';
    import { productService } from '../../../common/service/resource';

    export default {
        name: 'DulceForm',

        components: { Alert },

        data() {
            return {
                email: '',
                alert: null,
            };
        },

        mounted() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'page-type': 'product',
                'product-id': 12196,
                'product-name': 'Cerveja Dona Dulce',
                google_tag_params: {
                    ecomm_prodid: '12196',
                    ecomm_pagetype: 'product',
                },
                page: {
                    type: 'product', // This value must not change. Required
                    environment: 'production', // This value must not change. Required
                },
            });
        },

        methods: {
            submit() {
                if (this.validate()) this.registerEmail();
            },

            validate() {
                if (!this.email || this.email.trim().length <= 0) {
                    this.showError('Informe seu email');
                    return false;
                } else return true;
            },

            registerEmail() {
                productService
                    .requestReprint(12196, 448, {
                        email: this.email,
                    })
                    .then((data) => {
                        if (data && data.data && data.data.success) {
                            if (window.dataLayer) {
                                // todo não manda o id?
                                window.dataLayer.push({
                                    event: 'addToReprint',
                                    product_gender: 'Unisex',
                                    product_size: 'Padrão',
                                });
                            }
                            this.showSuccess();
                        } else {
                            this.showError();
                        }
                    })
                    .catch(() => this.showError());
            },

            showSuccess() {
                this.alert = {
                    message:
                        'Seu email foi cadastrado com sucesso e iremos te avisar quando o produto estiver disponível.',
                };
            },

            showError(message) {
                this.alert = {
                    message: message || 'Não foi possível cadastrar seu email.',
                    isError: true,
                };
            },
        },
    };
</script>
